import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { version } from '../../package.json'
import { Container } from "react-bootstrap"

const Footer = () => {
    const query = useStaticQuery(graphql`
        query {
            site {
                buildTime
            }
        }
    `)
    
    return (
        <Container>
            <footer className="text-center border-top py-3" 
                style={{"position":"relative","width":"100%"}}>
                <div>
                    <div>
                        <span className="text-muted">
                            2021-2024 CNM - Digital Services
                        </span>
                    </div>
                    <div>
                        <span className="text-muted">
                            {`Site version v${version} built at ${query.site.buildTime}`}
                        </span>
                    </div>
                </div>
            </footer>
        </Container>
    )
}

export default Footer